import React from 'react';
import { Hero } from '../components/Hero';
import { Challenge } from '../components/Challenge';
import { Solution } from '../components/Solution';
import { Features } from '../components/Features';
import { Impact } from '../components/Impact';
import { PatientExperience } from '../components/PatientExperience';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-gradient-to-b from-green-50 to-white" data-id="element-187">
      <Hero data-id="element-188" />
      <Challenge data-id="element-189" />
      <Solution data-id="element-190" />
      <PatientExperience data-id="element-191" />
      <Features data-id="element-192" />
      <Impact data-id="element-193" />
      <Footer data-id="element-194" />
    </div>;
}